import { Helmet } from "react-helmet-async";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function serviceLd(name, description, path) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        name,
        description,
        url: `${BASE}${path}`,
        provider: {
            "@type": "Organization",
            name: "Viet Medica Ltd",
            url: BASE,
        },
        areaServed: ["Mauritius", "Vietnam", "India", "Thailand", "China"],
    };
}

export function breadcrumbLd(crumbs) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: crumbs.map((c, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: c.label,
            ...(c.href ? { item: `${BASE}${c.href}` } : {}),
        })),
    };
}

export default function SEO({ title, description, path, jsonLd }) {
    const url = `${BASE}${path || "/"}`;
    const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Viet Medica Ltd" />
            {blocks.map((b, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(b)}
                </script>
            ))}
        </Helmet>
    );
}
